import type { Component } from 'solid-js';
import RobotMaintenance from './robot-maintenance.png';

export const MaintenancePage: Component = () => {
  return (
    <div class="bg-primary flex min-h-screen flex-col items-center justify-center from-blue-50 px-4">
      <div class="w-full max-w-md rounded-lg bg-white p-8 shadow-xl">
        <div class="mb-6 flex justify-center">
          <img src={RobotMaintenance} alt="Logo" />
        </div>

        <h1 class="mb-4 text-center text-3xl font-bold text-gray-900">System upgrade in progress</h1>

        <p class="mb-6 text-center text-gray-600">We are currently performing scheduled maintenance and will be back shortly.</p>
      </div>
    </div>
  );
};
